import NewRecipeDialog from "../../components/recipeSimulator/NewRecipeDialog";
import UsageDialog from "../../components/recipeSimulator/UsageDialog";
import { TwScope } from "../../components/ui/TwScope";
import RecipeListConfirmDialogs from "./newList/components/RecipeListConfirmDialogs";
import RecipeListHeader from "./newList/components/RecipeListHeader";
import RecipeListPagination from "./newList/components/RecipeListPagination";
import RecipeListSearch from "./newList/components/RecipeListSearch";
import RecipeListTable from "./newList/components/RecipeListTable";
import { useRecipeSimulatorList } from "./newList/hooks/useRecipeSimulatorList";

const RecipeSimulatorNewListView = () => {
  const {
    isAdmin,
    currentUserId,
    search,
    setSearch,
    toggleSort,
    pageNumber,
    setPageNumber,
    totalPages,
    totalCount,
    sortedRecords,
    isInitialTableLoading,
    isTableRefetching,
    isSearchPending,
    isRecipeDeleteLoading,
    isRecipeTypeUpdateLoading,
    newRecipeOpen,
    setNewRecipeOpen,
    usageOpen,
    setUsageOpen,
    usageTargetName,
    usageRecords,
    isUsageLoading,
    demoConfirmOpen,
    setDemoConfirmOpen,
    deleteConfirmOpen,
    setDeleteConfirmOpen,
    deleteConfirmTarget,
    publicConfirmOpen,
    setPublicConfirmOpen,
    privateConfirmOpen,
    setPrivateConfirmOpen,
    confirmDelete,
    confirmMakeDemo,
    confirmMakePublic,
    confirmMakePrivate,
    privateConfirmTarget,
    refetchRecipeList,
    rowHandlers
  } = useRecipeSimulatorList();

  return (
    <TwScope className="tw-p-8 tw-bg-white tw-min-h-full">
      <RecipeListHeader onAddRecipe={() => setNewRecipeOpen(true)} />
      <RecipeListSearch
        value={search}
        onChange={setSearch}
        isLoading={isSearchPending || isTableRefetching}
      />
      <RecipeListTable
        isAdmin={isAdmin}
        currentUserId={currentUserId}
        isInitialLoading={isInitialTableLoading}
        isRefetching={isTableRefetching}
        records={sortedRecords}
        onSort={toggleSort}
        handlers={rowHandlers}
      />
      <RecipeListPagination
        totalCount={totalCount}
        pageNumber={pageNumber}
        totalPages={totalPages}
        onPageChange={setPageNumber}
        isRefreshing={isTableRefetching}
      />

      <NewRecipeDialog
        open={newRecipeOpen}
        onOpenChange={setNewRecipeOpen}
        onSuccess={refetchRecipeList}
      />
      <UsageDialog
        open={usageOpen}
        onOpenChange={setUsageOpen}
        demoKitName={usageTargetName}
        usageRecords={usageRecords}
        isLoading={isUsageLoading}
      />
      <RecipeListConfirmDialogs
        demoConfirmOpen={demoConfirmOpen}
        onDemoConfirmOpenChange={setDemoConfirmOpen}
        onConfirmMakeDemo={confirmMakeDemo}
        deleteConfirmOpen={deleteConfirmOpen}
        deleteConfirmTarget={deleteConfirmTarget}
        onDeleteConfirmOpenChange={setDeleteConfirmOpen}
        onConfirmDelete={confirmDelete}
        publicConfirmOpen={publicConfirmOpen}
        onPublicConfirmOpenChange={setPublicConfirmOpen}
        onConfirmMakePublic={confirmMakePublic}
        privateConfirmOpen={privateConfirmOpen}
        onPrivateConfirmOpenChange={setPrivateConfirmOpen}
        onConfirmMakePrivate={confirmMakePrivate}
        privateConfirmTarget={privateConfirmTarget}
        isDeleteConfirmLoading={isRecipeDeleteLoading}
        isDemoConfirmLoading={isRecipeTypeUpdateLoading && demoConfirmOpen}
        isPublicConfirmLoading={isRecipeTypeUpdateLoading && publicConfirmOpen}
        isPrivateConfirmLoading={isRecipeTypeUpdateLoading && privateConfirmOpen}
      />
    </TwScope>
  );
};

export default RecipeSimulatorNewListView;
